/**
 * Session Management for Blog Analytics
 *
 * Generates and stores a persistent session ID for tracking
 * user engagement across blog visits.
 */

const SESSION_KEY = "blog_session_id";

/**
 * Get or create a session ID for analytics tracking
 */
export function getSessionId(): string {
  if (typeof window === "undefined") return "";

  let sessionId = localStorage.getItem(SESSION_KEY);

  if (!sessionId) {
    // Generate a unique session ID
    sessionId = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
    localStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
}

/**
 * Clear the session ID (useful for testing)
 */
export function clearSessionId(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(SESSION_KEY);
}

/**
 * Check if session ID exists
 */
export function hasSessionId(): boolean {
  if (typeof window === "undefined") return false;
  return !!localStorage.getItem(SESSION_KEY);
}
